import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import useAuthStore from '../store/useAuthStore';
import {pageRoutes} from '.';

const isInvigilatorAllowed = (pathname) => {
  return pathname === '/' || pathname.startsWith('/assessments');
};

const ProtectedRoute = ({children}) => {
  // const isLogin = true;
  const isLogin = useAuthStore((state) => state.isLogin);
  const user = useAuthStore((state) => state.user);
  const location = useLocation();

  if (!isLogin) {
    return <Navigate to="/login" />;
  }

  // Role-based protection
  if (user?.role === 'invigilator') {
    if (!isInvigilatorAllowed(location.pathname)) {
      return <Navigate to={pageRoutes.dashboard} replace />;
    }
  }

  // Admin can access all routes
  return children;
};

export default ProtectedRoute;
